module.exports = __webpack_public_path__ + "static/media/AmericanExpress.6cbc018a.svg";